<div id="main">

    <button id="close" mat-dialog-close>
        <fa-icon [icon]="faTimes"></fa-icon>
    </button>

    <div id="parametersCont">
        <h4>{{'LAST_MEASURE_TITLE'|translate}}</h4>
        <div class="filter-for-list">
            <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
                <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
            </mat-form-field>
          <mat-slide-toggle style="padding-top: 25px; padding-left: 50px;"
                            (click)="activeOrInactiveLocation()">{{getActiveTextForSlider()}}</mat-slide-toggle>

            <br clear="both"/>
        </div>
        <app-progressbar *ngIf="isLoading===true"></app-progressbar>
        <table mat-table [dataSource]="locationsList" matSort class="table-striped" style="width:100%">


            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
                <td mat-cell *matCellDef="let location">
                    <mat-chip-list>
                        <mat-chip class="location">
                            {{location.name}}
                        </mat-chip>
                    </mat-chip-list>
                </td>
            </ng-container>
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
                <td mat-cell *matCellDef="let location">
                    {{location.id}}
                </td>
            </ng-container>
            <ng-container matColumnDef="last_measure_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DATE'|translate}}</th>
                <td mat-cell *matCellDef="let location">
                    {{location.last_measure_date ? location.last_measure_date : '-'}}
                </td>
            </ng-container>
          <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ACTIVE'|translate}}</th>
            <td mat-cell *matCellDef="let location">
              <fa-icon *ngIf="location.active === true" [icon]="faSmile" style="color:green;font-size: 25px;"></fa-icon>
              <fa-icon *ngIf="location.active === false" [icon]="faSadTear" style="color:red;font-size: 25px;"></fa-icon>
            </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>


        <br clear="left"/>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>
    </div>
</div>
